import React, { useState, useEffect } from 'react';
import {
  Grid,
  TextField,
  Typography,
  Box,
  Button,
  Card,
} from '@mui/material';
import MKBox from "components/MKBox";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import Container from "@mui/material/Container";
import MKButton from "components/MKButton";
import routes from "trainerEditRoutes";
import { useParams } from "react-router-dom";
import Breadcrumbs from "examples/Breadcrumbs";
import SimpleFooter from "examples/Footers/SimpleFooter";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Modal from "@mui/material/Modal";
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { getAllInfoByISO } from 'iso-country-currency';
import MKAlert from "components/MKAlert";
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import Rating from '@mui/material/Rating';
import Stack from '@mui/material/Stack';
import IdleTimeOutHandler from "pages/IdleTimeHandler/IdleTimeOutHander";

const LoadingOverlay = ({ loading, children }) => {
  return (
    <>
      {loading && (
        <Backdrop
          sx={{
            color: '#fff',
            zIndex: (theme) => theme.zIndex.drawer + 1,
            filter: 'blur(5px)',
            pointerEvents: 'none',
          }}
          open={loading}
        >
          <Box
            sx={{
              p: 2,
              mx: { xs: 2, lg: 3 },
              // mt: -8,
              mb: 4,
              backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
              backdropFilter: "saturate(200%) blur(30px)",
              boxShadow: ({ boxShadows: { xxl } }) => xxl,
              position: "absolute",
              top: "0",
              left: "0",
              zIndex: "1",
              width: "100%",
              minHeight: "100vh",
              // display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              pointerEvents: 'none',
              userSelect: 'none',
            }}
          >
            {children}
          </Box>
        </Backdrop>
      )}
      {loading && (
        <Box
          sx={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: (theme) => theme.zIndex.drawer + 2,
          }}
        >
          <CircularProgress />
        </Box>
      )}
      {!loading && children}
    </>
  );
};

function Author() {
  const { trainingID } = useParams();
  const [trainingDetails, setTrainingDetails] = useState([]);
  const [bbdata, setbbData] = useState([]);
  const [trainingList, setTrainingList] = useState([]);
  const [submitCompleted, setSubmitCompleted] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [trainerDetails, setTrainerDetails] = useState([]);
  const [selectedCurrencyCountry, setSelectedCurrencyCountry] = useState('');
  const [commercialsCurrency, setCommercialsCurrency] = useState("");
  const [commercialsLessThan4hrs, setCommercialsLessThan4hrs] = useState("");
  const [commercials4hrs, setCommercials4hrs] = useState("");
  const [commercials8hrs, setCommercials8hrs] = useState("");
  const [lastDeliveredDate, setLastDeliveredDate] = useState("");
  const [lastClient, setLastClient] = useState("");
  const [courseDuration, setCourseDuration] = useState("");
  const [trainingAvailableDate, setTrainingAvailableDate] = useState([]);
  const [callAvailableDate, setCallAvailableDate] = useState([]);
  const [trainingComment, settrainingComment] = useState("");
  const [userId, setUserId] = useState("");
  const [currency, setCurrency] = useState('');
  const [trainerProfile, setTrainerProfile] = useState("");
  const [selectedTrainingCompanyId, setSelectedTrainingCompanyId] = useState("");
  const [selectedTraining, setSelectedTraining] = useState(null);
  const [selectedTrainingName, setSelectedTrainingName] = useState("");
  const [selectedTrainingID, setSelectedTrainingID] = useState("");
  const [lab, setLab] = useState("");
  const [labCostPerParticipants, setLabCostPerParticipants] = useState("");
  const [serverCount, setServerCount] = useState("");
  const [typeOfServer, setTypeOfServer] = useState("");
  const [submitAcceptCompleted, setSubmitAcceptCompleted] = useState(false);
  const [submitTrainingAcceptCompleted, setSubmitTrainingAcceptCompleted] = useState(false);
  const [submitConfirmTrainingCompleted, setSubmitConfirmTrainingCompleted] = useState(false);
  const [submitInvoiceSentCompleted, setSubmitInvoiceSentCompleted] = useState(false);
  const [maxRemainderCount, setMaxRemainderCount] = useState("");
  const [responseFromDB, setResponseFromDB] = useState("");
  const [loading, setLoading] = useState(false);
  const [feedbackQuestions, setFeedbackQuestions] = useState([]);
  const [feedbackRating, setFeedbackRating] = useState(0);
  const [isFeedback1Interacted, setIsFeedback1Interacted] = useState(false);
  const [feedbackAnswer1, setFeedbackAnswer1] = useState("");
  const [isFeedback2Interacted, setIsFeedback2Interacted] = useState(false);
  const [feedbackAnswer2, setFeedbackAnswer2] = useState("");
  const [isFeedback3Interacted, setIsFeedback3Interacted] = useState(false);
  const [feedbackAnswer3, setFeedbackAnswer3] = useState("");
  const [isFeedback4Interacted, setIsFeedback4Interacted] = useState(false);
  const [feedbackAnswer4, setFeedbackAnswer4] = useState("");
  const [isFeedback5Interacted, setIsFeedback5Interacted] = useState(false);
  const [feedbackAnswer5, setFeedbackAnswer5] = useState("");
  const [isFeedback6Interacted, setIsFeedback6Interacted] = useState(false);
  const [feedbackAnswer6, setFeedbackAnswer6] = useState("");
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [feedbackStatusAvailable, setFeedbackStatusAvailable] = useState(false);


  useEffect(() => {
    console.log("trainingID", trainingID);
    fetch(`${process.env.REACT_APP_API_URL}/api/applied-training-more-details/${trainingID}/`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (!data.detail) {
          setbbData(data);
          setTrainingDetails(data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  console.log("trainingDetails", trainingDetails);
  console.log("data", bbdata);



  useEffect(() => {
    let id = localStorage.getItem("userId");
    setUserId(id);
    fetch(`${process.env.REACT_APP_API_URL}/api/trainer-profile-list/${id}/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
        } else {
          setTrainerDetails(data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);
  console.log("trainerDetails", trainerDetails);

  const onAgreeClick = (training) => {
    setLoading(true);
    console.log("111111111111111111", training);
    const data = {
      applyTrainingStatus: "3",
      previousStatus: "2",
      appliedTrainerID: training.appliedTrainerID,
      trainingCompanyUserID: training.trainingCompanyUserID,
      selectedTrainingID: training.selectedTrainingID,
      selectedTrainingName: training.trainingName,
    };
    console.log(JSON.stringify(data));
    fetch(`${process.env.REACT_APP_API_URL}/api/trainerdashboard-status-intodb/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),

    })
      .then((response) => {
        if (response.ok) {
          console.log("aaaaaaaaaaa");
          setSubmitTrainingAcceptCompleted(true);
          setLoading(false);
        } else {
          setSubmitTrainingAcceptCompleted(false);
          throw new Error("Response not posted. Something went wrong");
        }
      })
      .then((data) => {
        console.log("fffffffffffffffff");
      })
      .catch((error) => {
        console.log("oooooooooooooooo", error.message);
      });
  };

  const onConfirmTrainingClick = (training) => {
    setLoading(true);
    console.log("111111111111111111", training);
    const data = {
      applyTrainingStatus: "6",
      previousStatus: "5",
      appliedTrainerID: training.appliedTrainerID,
      trainingCompanyUserID: training.trainingCompanyUserID,
      selectedTrainingID: training.selectedTrainingID,
      selectedTrainingName: training.trainingName,
    };
    console.log(JSON.stringify(data));
    fetch(`${process.env.REACT_APP_API_URL}/api/trainerdashboard-status-intodb/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),

    })
      .then((response) => {
        if (response.ok) {
          console.log("aaaaaaaaaaa");
          setSubmitConfirmTrainingCompleted(true);
          setLoading(false);
        } else {
          setSubmitConfirmTrainingCompleted(false);
          throw new Error("Response not posted. Something went wrong");
        }
      })
      .then((data) => {
        console.log("fffffffffffffffff");
      })
      .catch((error) => {
        console.log("oooooooooooooooo", error.message);
      });
  };

  const onSendInvoiceClick = (training) => {
    setLoading(true);
    console.log("111111111111111111", training);
    const data = {
      applyTrainingStatus: "9",
      previousStatus: "8",
      appliedTrainerID: training.appliedTrainerID,
      trainingCompanyUserID: training.trainingCompanyUserID,
      selectedTrainingID: training.selectedTrainingID,
      selectedTrainingName: training.trainingName,
    };
    console.log(JSON.stringify(data));
    fetch(`${process.env.REACT_APP_API_URL}/api/trainerdashboard-status-intodb/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),

    })
      .then((response) => {
        if (response.ok) {
          console.log("aaaaaaaaaaa");
          setSubmitInvoiceSentCompleted(true);
          setLoading(false);
        } else {
          setSubmitInvoiceSentCompleted(true);
          throw new Error("Response not posted. Something went wrong");
        }
      })
      .then((data) => {
        console.log("fffffffffffffffff");
      })
      .catch((error) => {
        console.log("oooooooooooooooo", error.message);
      });
  };

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/feedback-template-view/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
        } else {
          const trainerFeedbackQuestions = data.filter(
            (question) => question.toWhom === "Trainer"
          );
          setFeedbackQuestions(trainerFeedbackQuestions);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  console.log("feedbackQuestions", feedbackQuestions);

  const handleRatingChange = (event, newValue) => {
    // Update the feedbackRating state with the selected rating
    setFeedbackRating(newValue);
  };

  function getFeedbackStatus(training) {
    let trainerId = training.appliedTrainerID;
    let trainingCompanyID = training.trainingCompanyUserID;
    let trainingID = training.selectedTrainingID.toString();
    let toWhom = "TrainingCompany";

    fetch(`${process.env.REACT_APP_API_URL}/api/check-feedback-exists/${trainerId}/${trainingCompanyID}/${trainingID}/${toWhom}/`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data) {
          console.log("Data is true", data);
          setFeedbackStatusAvailable(false);
        } else {
          console.log("Data is false or undefined", data);
          setFeedbackStatusAvailable(true);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  const onPaymentReceivedClick = (training) => {
    if (feedbackStatusAvailable && (parseInt(training.applyTrainingStatus) === 10 || parseInt(training.applyTrainingStatus) === 12 || parseInt(training.applyTrainingStatus) === 17 || parseInt(training.applyTrainingStatus) === 18 || parseInt(training.applyTrainingStatus) === 19 || parseInt(training.applyTrainingStatus) === 20)) {
      setShowFeedbackModal(true);
    }
  };

  const [submitPaymentReceivedCompleted, setSubmitPaymentReceivedCompleted] = useState(false);
  const [submitPaymentNotReceivedCompleted, setSubmitPaymentNotReceivedCompleted] = useState(false);
  const [feedbackCompleted, setFeedbackCompleted] = useState(false);

  const onSubmitFeedbackClick = (training) => {
    setLoading(true);
    const data = {
      trainerID: training.appliedTrainerID,
      trainingCompanyID: training.trainingCompanyUserID,
      trainingID: training.selectedTrainingID.toString(),
      toWhom: "TrainingCompany",
      rating1: feedbackRating,
      question1: feedbackAnswer1,
      question2: feedbackAnswer2,
      question3: feedbackAnswer3,
      question4: feedbackAnswer4,
      question5: feedbackAnswer5,
      question6: feedbackAnswer6,
      status: "Active",
    };

    fetch(`${process.env.REACT_APP_API_URL}/api/feedback-api-view/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (response.ok) {
          console.log("Feedback submitted successfully");
          setFeedbackCompleted(true);
          // After feedback is submitted successfully, perform the status update
          const statusUpdateData = {
            applyTrainingStatus: "11",
            previousStatus: "10",
            appliedTrainerID: training.appliedTrainerID,
            trainingCompanyUserID: training.trainingCompanyUserID,
            selectedTrainingID: training.selectedTrainingID,
            selectedTrainingName: training.trainingName,
          };

          return fetch(`${process.env.REACT_APP_API_URL}/api/trainerdashboard-status-intodb/`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(statusUpdateData),
          });
        } else {
          setFeedbackCompleted(false);
          throw new Error("Feedback not submitted. Something went wrong");
        }
      })
      .then((statusUpdateResponse) => {
        if (statusUpdateResponse.ok) {
          console.log("Status update completed successfully");
          setShowFeedbackModal(false);
          // setTrainerWithPayment(false);
          setSubmitPaymentReceivedCompleted(true);
          setLoading(false);
        } else {
          setSubmitPaymentReceivedCompleted(false);
          throw new Error("Status update failed. Something went wrong");
        }
      })
      .catch((error) => {
        console.log("Error:", error.message);
      });
  };

  const onPaymentNotReceivedClick = (training) => {
    setLoading(true);
    console.log("111111111111111111", training);
    const data = {
      applyTrainingStatus: "12",
      previousStatus: training.applyTrainingStatus,
      appliedTrainerID: training.appliedTrainerID,
      trainingCompanyUserID: training.trainingCompanyUserID,
      selectedTrainingID: training.selectedTrainingID,
      selectedTrainingName: training.trainingName,
    };
    console.log(JSON.stringify(data));
    fetch(`${process.env.REACT_APP_API_URL}/api/trainerdashboard-status-intodb/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),

    })
      .then((response) => {
        if (response.ok) {
          console.log("aaaaaaaaaaa");
          // setTrainerWithPayment(false);
          setSubmitPaymentNotReceivedCompleted(true);
          setLoading(false);
        } else {
          setSubmitPaymentNotReceivedCompleted(false);
          throw new Error("Response not posted. Something went wrong");
        }
      })
      .then((data) => {
        console.log("fffffffffffffffff");
      })
      .catch((error) => {
        console.log("oooooooooooooooo", error.message);
      });
  };

  const DialogProfileAcceptClose = () => {
    setSubmitAcceptCompleted(false);
    window.location.href = `/app/appliedtrainingmoredetails/${trainingID}`;
  };

  const DialogProfileTrainingAcceptClose = () => {
    setSubmitTrainingAcceptCompleted(false);
    window.location.href = `/app/appliedtrainingmoredetails/${trainingID}`;
  };

  const DialogProfileConfirmTrainingClose = () => {
    setSubmitConfirmTrainingCompleted(false);
    window.location.href = `/app/appliedtrainingmoredetails/${trainingID}`;
  };

  const DialogProfileInvoiceSentClose = () => {
    setSubmitInvoiceSentCompleted(false);
    window.location.href = `/app/appliedtrainingmoredetails/${trainingID}`;
  };

  const DialogFeebackClose = () => {
    setFeedbackCompleted(false);
    setShowFeedbackModal(false);
    setFeedbackStatusAvailable(false);
    // window.location.href = `/app/appliedtrainingmoredetails/${trainingID}`;
  };

  const DialogProfilePaymentReceivedClose = () => {
    setSubmitPaymentReceivedCompleted(false);
    window.location.href = `/app/appliedtrainingmoredetails/${trainingID}`;
  };

  const DialogProfilePaymentNotReceivedClose = () => {
    setSubmitPaymentNotReceivedCompleted(false);
    window.location.href = `/app/appliedtrainingmoredetails/${trainingID}`;
  };

  const onRemainderClick = (e) => {
    setLoading(true);
    setMaxRemainderCount(false);
    const data = {
      id: trainingID,
      premiumStatus: trainerDetails.premiumStatus,
    };
    console.log(JSON.stringify(data));
    fetch(`${process.env.REACT_APP_API_URL}/api/apply-training-reminder/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          setSubmitCompleted(false);
          throw new Error("Profile is not created. Something went wrong");
        }
      })
      .then((data) => {
        console.log("Response from backend:", data.message);
        if (data.message === "Remainder reached maximum for the day") {
          setResponseFromDB(data.message);
          setMaxRemainderCount(true);
          setLoading(false);
        } else if (data.message === "We have re-sent you a link to the company to accept your request") {
          setResponseFromDB(data.message);
          setSubmitCompleted(true);
          setLoading(false);
        } else {
          setResponseFromDB(data.message);
          setSubmitCompleted(false);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log("Error:", error.message);
      });
  };


  const DialogProfileClose = () => {
    window.location.href = "/app/trainerdashboard";
  };

  const onCancelClick = () => {
    window.location.href = "/app/trainerdashboard";
  };

  function getStatusMessage(trainingDetails) {
    console.log("training.applyTrainingStatus", trainingDetails.applyTrainingStatus);
    if (trainingDetails.applyTrainingStatus === "1") {
      return "Awaiting For Training Partner's response";
    } else if (trainingDetails.applyTrainingStatus === "2") {
      return "Partner - Accepted. Awaiting for your response";
    } else if (trainingDetails.applyTrainingStatus === "13") {
      return "Training Partner has Declined your request";
    } else if (trainingDetails.applyTrainingStatus === "3") {
      return "Mutually agreed for the training";
    } else if (trainingDetails.applyTrainingStatus === "14") {
      return "Trainer Declined the training";
    } else if (trainingDetails.applyTrainingStatus === "4") {
      return "Discussion on-going with Training Partner";
    } else if (trainingDetails.applyTrainingStatus === "5") {
      return "Training Scheduled - Awaiting for your Confirmation";
    } else if (trainingDetails.applyTrainingStatus === "6") {
      return "Training Scheduling confirmed with Training Partner";
    } else if (trainingDetails.applyTrainingStatus === "7") {
      return "Training has been Started";
    } else if (trainingDetails.applyTrainingStatus === "8") {
      return "Training has been Completed";
    } else if (trainingDetails.applyTrainingStatus === "9") {
      return "Invoice sent to the Training Partner";
    } else if (trainingDetails.applyTrainingStatus === "10") {
      return "Payment Completed by the Training Partner";
    } else if (trainingDetails.applyTrainingStatus === "11") {
      return "Payment Received by the Trainer";
    } else if (trainingDetails.applyTrainingStatus === "12") {
      return "Payment Not Received by the Trainer";
    } else if (trainingDetails.applyTrainingStatus === "16") {
      return "Your training request is on-hold by Training Partner";
    } else if (trainingDetails.applyTrainingStatus === "17") {
      return "1st New Payment Date given by Training Partner";
    } else if (trainingDetails.applyTrainingStatus === "18") {
      return "2nd New Payment Date given by Training Partner";
    } else if (trainingDetails.applyTrainingStatus === "19") {
      return "Final New Payment Date given by Training Partner";
    } else {
      return "Unknown Status";
    }
  }

  const handleTrainerTocDownloadClick = (trainingDetails) => {
    console.log("url", trainingDetails);

    window.location.href = `${process.env.REACT_APP_API_URL}/api/download/${trainingDetails.tocURL}/applytraining/${trainingDetails.trainingName}_${trainingDetails.selectedTrainingID}_toc`;
  };

  const handleTrainingCompanyTocDownloadClick = (trainingDetails) => {

    console.log("url", trainingDetails);
    window.location.href = `${process.env.REACT_APP_API_URL}/api/download/${trainingDetails.TOCURL}/trainingpost/${trainingDetails.selectedTrainingName}_toc`;
  };

  return (
    <>
      <LoadingOverlay loading={loading}>
        <IdleTimeOutHandler />
        <DefaultNavbar
          routes={routes}
        />
        <MKBox bgColor="white">
          <Card
            sx={{
              p: 2,
              mx: { xs: 2, lg: 3 },
              // mt: -8,
              mb: 4,
              backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
              backdropFilter: "saturate(200%) blur(30px)",
              boxShadow: ({ boxShadows: { xxl } }) => xxl,
            }}
          >
            <Dialog
              open={submitAcceptCompleted}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                Notification !
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Your response submitted to the training partner.
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                {/* <Button onClick={DialogClose} color="primary" autoFocus> */}
                <MKButton onClick={() => { setSubmitAcceptCompleted(false); DialogProfileAcceptClose(); }} variant="gradient" color="info" size='small' autoFocus>
                  OK
                </MKButton>
              </DialogActions>
            </Dialog>
            <Dialog
              open={submitTrainingAcceptCompleted}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                Success!
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Your acceptance response has been submitted to the training partner. Please await confirmation as the training partner reviews and accepts your request. Get ready for an exciting collaboration!
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                {/* <Button onClick={DialogClose} color="primary" autoFocus> */}
                <MKButton onClick={() => { setSubmitTrainingAcceptCompleted(false); DialogProfileTrainingAcceptClose(); }} variant="gradient" color="info" size="small" autoFocus>
                  OK
                </MKButton>
              </DialogActions>
            </Dialog>
            <Dialog
              open={submitConfirmTrainingCompleted}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                Confirmation!
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Your training schedule is now officially confirmed. Prepare for a successful and enriching training experience!
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                {/* <Button onClick={DialogClose} color="primary" autoFocus> */}
                <MKButton onClick={() => { setSubmitConfirmTrainingCompleted(false); DialogProfileConfirmTrainingClose(); }} variant="gradient" color="info" size='small' autoFocus>
                  OK
                </MKButton>
              </DialogActions>
            </Dialog>
            <Dialog
              open={submitInvoiceSentCompleted}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                Confirmation received!
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Your acknowledgment of the invoice submission has been duly registered.
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                {/* <Button onClick={DialogClose} color="primary" autoFocus> */}
                <MKButton onClick={() => { setSubmitInvoiceSentCompleted(false); DialogProfileInvoiceSentClose(); }} variant="gradient" color="info" size='small' autoFocus>
                  OK
                </MKButton>
              </DialogActions>
            </Dialog>
            <Dialog
              open={submitCompleted}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                Great news!
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Reminder sent successfully! Your gentle nudge has been delivered.
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                {/* <Button onClick={DialogClose} color="primary" autoFocus> */}
                <MKButton onClick={() => { setSubmitCompleted(false); DialogProfileClose(); }} variant='gradient' color="info" size='small' autoFocus>
                  OK
                </MKButton>
              </DialogActions>
            </Dialog>
            <Dialog
              open={submitPaymentNotReceivedCompleted}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                Success!
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  We've promptly informed the training partner about the non receipt of the payment
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                {/* <Button onClick={DialogClose} color="primary" autoFocus> */}
                <MKButton onClick={() => { setSubmitPaymentNotReceivedCompleted(false); DialogProfilePaymentNotReceivedClose(); }} variant="gradient" color="info" size="small" autoFocus>
                  OK
                </MKButton>
              </DialogActions>
            </Dialog>
            <Dialog
              open={submitPaymentReceivedCompleted}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                Success!
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Your payment receipt confirmation has been submitted to the training partner.
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                {/* <Button onClick={DialogClose} color="primary" autoFocus> */}
                <MKButton onClick={() => { setSubmitPaymentReceivedCompleted(false); DialogProfilePaymentReceivedClose(); }} variant="gradient" color="info" size="small" autoFocus>
                  OK
                </MKButton>
              </DialogActions>
            </Dialog>
            <Dialog
              open={feedbackCompleted}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                Notification !
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Your response submitted to the training company.
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                {/* <Button onClick={DialogClose} color="primary" autoFocus> */}
                <MKButton onClick={() => { setFeedbackCompleted(false); DialogFeebackClose(); }} variant="gradient" color="info" size="small" autoFocus>
                  OK
                </MKButton>
              </DialogActions>
            </Dialog>
            <MKBox component="section" py={{ xs: 6, sm: 12 }}>
              <Container>
                <div>
                  {maxRemainderCount ? (
                    <MKAlert color="error" dismissible >
                      You've reached the daily remainder limit !
                    </MKAlert>
                  ) : (
                    ""
                  )}
                </div>
                <Grid container item xs={12} justifyContent="center" mx="auto">
                  <Grid container justifyContent="center" py={6} style={{ marginTop: "-50px" }}>
                    <Grid item xs={12} md={12} mx={{ xs: "auto", sm: 6, md: 1 }}>
                      <MKBox display="flex" justifyContent="center" alignItems="center" mb={1}>
                        <Typography variant="h3">{trainingDetails.trainingName}</Typography>
                      </MKBox>

                      <MKBox display="flex" justifyContent="center" alignItems="center" mb={1}>
                        <Grid item>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text">
                            Training by :
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "10px" }}>
                            {trainingDetails.trainingCompanyName}
                          </Typography>
                        </Grid>
                      </MKBox>

                      <MKBox display="flex" justifyContent="center" alignItems="center" mb={1}>
                        <Grid item>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text">
                            Technology:
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "10px" }}>
                            {trainingDetails.technology}
                          </Typography>
                        </Grid>
                      </MKBox>

                      <MKBox display="flex" justifyContent="center" alignItems="center" mb={1}>
                        <Grid item>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text">
                            <strong>Status:</strong>
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "10px" }}>
                            <strong>{getStatusMessage(trainingDetails)}</strong>
                          </Typography>
                        </Grid>
                      </MKBox>

                      <Grid container spacing={1} mb={1} style={{ marginTop: "10px" }}>
                        <Grid item xs={12}>
                          <Breadcrumbs routes={[{ label: <span style={{ fontWeight: 'bold' }}>Training Details</span> }]} />
                        </Grid>
                      </Grid>

                      <Grid container spacing={4} mb={1}>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                            Mode Of Training :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "48px" }}>
                            {trainingDetails.trainingMode}
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text">
                            Training Location :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "50px" }}>
                            {trainingDetails.trainingMode === "Virtual" ? "N/A" : trainingDetails.trainingLocations}
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" >
                            Time Zone :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "88px" }}>
                            {trainingDetails.timeZone}
                          </Typography>
                        </Grid>
                      </Grid>

                      <Grid container spacing={4} mb={1}>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }} >
                            Audience Level :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "63px" }}>
                            {trainingDetails.audienceLevel}
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text">
                            Training Expectation :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "27px" }}>
                            {trainingDetails.trainingExpectation}
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text">
                            Training Type :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "69px" }}>
                            {trainingDetails.trainingType}
                          </Typography>
                        </Grid>
                      </Grid>

                      <Grid container spacing={4} mb={1}>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                            Total Participants :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "47px" }}>
                            {trainingDetails.totalParticipants}
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text">
                            Total Training Budget :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "20px" }}>
                            {trainingDetails.currency}&nbsp;{trainingDetails.totalTrainingBudget}
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" >
                            Total Duration :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "63px" }}>
                            {trainingDetails.duration}&nbsp;hours
                          </Typography>
                        </Grid>
                      </Grid>

                      <Grid container spacing={4} mb={1}>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                            Training Timing :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "63px" }}>
                            {trainingDetails.trainingTiming}
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" >
                            Start Time :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "99px" }}>
                            {trainingDetails.startTime}
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text">
                            End Time :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "100px" }}>
                            {trainingDetails.endTime}
                          </Typography>
                        </Grid>
                      </Grid>

                      <Grid container spacing={4} mb={1}>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                            Expected Start Date :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "34px" }}>
                            {trainingDetails.expectedStartDate}
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text">
                            Expected End Date :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "35px" }}>
                            {trainingDetails.deadline}
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" >
                            TOC Available :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "70px" }}>
                            {trainingDetails.tocAvailable === 'yes' ? 'Yes' : 'No'}
                          </Typography>
                        </Grid>
                      </Grid>

                      {trainingDetails.tocAvailable === 'yes' && (
                        <Grid container spacing={4} mb={1}>
                          <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
                            <MKButton variant="gradient" color="info" size="small" style={{ padding: '5px 10px' }} onClick={() => handleTrainingCompanyTocDownloadClick(trainingDetails)}>
                              Download Training Partner TOC
                            </MKButton>
                          </Grid>
                        </Grid>
                      )}

                      <Grid container spacing={4} mb={1}>
                        <Grid item xs={12}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                            Training Schedule :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "58px" }}>
                            {/* {trainingDetails.trainingSchedule} */}
                            {trainingDetails.trainingSchedule
                              ? trainingDetails.trainingSchedule
                                .replace(/'/g, "")
                                .replace(/\[|\]/g, "")
                                .split(", ")
                                .join(", ")
                              : ""}
                          </Typography>
                        </Grid>
                      </Grid>

                      {trainingDetails.trainingScheduleComment && (
                        <>
                          <Grid container spacing={4} mb={1}>
                            <Grid item xs={2}>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                                Schedule Comments :&nbsp;
                              </Typography>
                            </Grid>
                            <Grid item xs={10}>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "0px" }}>
                                {trainingDetails.trainingScheduleComment} <br />
                              </Typography>
                            </Grid>
                          </Grid>
                        </>
                      )}

                      <Grid container spacing={4} mb={1}>
                        <Grid item xs={2}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                            Requirements :&nbsp;
                          </Typography>
                        </Grid>
                        <Grid item xs={10}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "0px" }}>
                            {trainingDetails.requirements} <br />
                          </Typography>
                        </Grid>
                      </Grid>

                      {(
                        trainerDetails.premiumStatus === "yes" ||
                        (parseInt(trainingDetails.applyTrainingStatus) >= 3 && parseInt(trainingDetails.previousStatus) >= 2)
                      ) && (
                          <>
                            <Grid container spacing={1} mb={1} style={{ marginTop: "10px" }}>
                              <Grid item xs={12}>
                                <Breadcrumbs
                                  routes={[{ label: <span style={{ fontWeight: 'bold' }}>Training Partner's Contact Details</span> }]}
                                />
                              </Grid>
                            </Grid>
                            <Grid container spacing={4} mb={1}>
                              <Grid item xs={4}>
                                <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                                  Contact Person Name :&nbsp;
                                </Typography>
                                <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "37px" }}>
                                  {trainingDetails.contactPerson}
                                </Typography>
                              </Grid>
                              <Grid item xs={4}>
                                <Typography component="span" variant="body2" fontWeight="regular" color="text" >
                                  Email - ID :&nbsp;
                                </Typography>
                                <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "50px" }}>
                                  {trainingDetails.email}&nbsp;
                                </Typography>
                              </Grid>
                              <Grid item xs={4}>
                                <Typography component="span" variant="body2" fontWeight="regular" color="text">
                                  Mobile Number :&nbsp;
                                </Typography>
                                <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "70px" }}>
                                  {trainingDetails.mobileNumber}&nbsp;
                                </Typography>
                              </Grid>
                            </Grid>

                          </>
                        )}

                      <Grid container spacing={1} mb={1} style={{ marginTop: "10px" }}>
                        <Grid item xs={12}>
                          <Breadcrumbs routes={[{ label: <span style={{ fontWeight: 'bold' }}>Trainer Application Details</span> }]} />
                        </Grid>
                      </Grid>

                      <Grid container spacing={4} mb={1}>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                            Last Delivered Date :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "70px" }}>
                            {trainingDetails.recentLastDeliveredDate}
                          </Typography>
                        </Grid>
                        <Grid item xs={8}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" >
                            Last Delivered Client :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "63px" }}>
                            {trainingDetails.recentLastDeliveredClient}
                          </Typography>
                        </Grid>

                      </Grid>

                      <Grid container spacing={4} mb={1}>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                            Commercials For &lt;4hrs :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "44px" }}>
                            {trainingDetails.currency}&nbsp;{trainingDetails.commercialsForLessThan4hrs}
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" >
                            Commercials For 4hrs :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "54px" }}>
                            {trainingDetails.currency}&nbsp;{trainingDetails.commercialsFor4hrs}
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" >
                            Commercials For 8hrs :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "54px" }}>
                            {trainingDetails.currency}&nbsp;{trainingDetails.commercialsFor8hrs}
                          </Typography>
                        </Grid>
                      </Grid>

                      <Grid container spacing={4} mb={1}>
                        <Grid item xs={12}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                            Total Training Duration :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "48px" }}>
                            {trainingDetails.courseDurationHRS} hours
                          </Typography>
                        </Grid>
                      </Grid>

                      {trainingDetails.availableDatesForTraining && trainingDetails.availableDatesForTraining !== "[]" && (
                        <>
                          <Grid container spacing={4} mb={1}>
                            <Grid item xs={12}>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                                Available Dates for Training :&nbsp;
                              </Typography>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "18px" }}>
                                {trainingDetails.availableDatesForTraining
                                  ? trainingDetails.availableDatesForTraining
                                    .replace(/'/g, "")
                                    .replace(/\[|\]/g, "")
                                    .split(", ")
                                    .join(", ")
                                  : ""}
                              </Typography>
                            </Grid>
                          </Grid>
                        </>
                      )}

                      {trainingDetails.availableDatesForCall && trainingDetails.availableDatesForCall !== "[]" && (
                        <>
                          <Grid container spacing={4} mb={1}>
                            <Grid item xs={12}>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                                Available Dates for Call :&nbsp;
                              </Typography>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "48px" }}>
                                {trainingDetails.availableDatesForCall
                                  ? trainingDetails.availableDatesForCall
                                    .replace(/'/g, "")
                                    .replace(/\[|\]/g, "")
                                    .split(", ")
                                    .join(", ")
                                  : ""}
                              </Typography>
                            </Grid>
                          </Grid>
                        </>
                      )}

                      {trainingDetails.applyToc === 'yes' && (
                        <Grid container spacing={4} mb={1}>
                          <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
                            <MKButton variant="gradient" color="info" size="small" style={{ padding: '5px 10px' }} onClick={() => handleTrainerTocDownloadClick(trainingDetails)}>
                              Download Trainer TOC
                            </MKButton>
                          </Grid>
                        </Grid>
                      )}

                      {trainingDetails.comments && (
                        <>
                          <Grid container spacing={4} mb={1}>
                            <Grid item xs={12}>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                                Comments :&nbsp;
                              </Typography>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "16px" }}>
                                {trainingDetails.comments}
                              </Typography>
                            </Grid>
                          </Grid>
                        </>
                      )}

                      {parseInt(trainingDetails.applyTrainingStatus) >= 5 && parseInt(trainingDetails.applyTrainingStatus) !== 16
                        && parseInt(trainingDetails.applyTrainingStatus) !== 13 && parseInt(trainingDetails.applyTrainingStatus) !== 14 && (
                          <>
                            <Grid container spacing={1} mb={1} style={{ marginTop: "10px" }}>
                              <Grid item xs={12}>
                                <Breadcrumbs routes={[{ label: <span style={{ fontWeight: 'bold' }}>Finalized Training Details</span> }]} />
                              </Grid>
                            </Grid>

                            <Grid container spacing={4} mb={1}>
                              <Grid item xs={4}>
                                <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                                  Training Start Date :&nbsp;
                                </Typography>
                                <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "44px" }}>
                                  {trainingDetails.trainingStartDate}
                                </Typography>
                              </Grid>
                              <Grid item xs={4}>
                                <Typography component="span" variant="body2" fontWeight="regular" color="text" >
                                  Training End Date :&nbsp;
                                </Typography>
                                <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "54px" }}>
                                  {trainingDetails.trainingEndDate}
                                </Typography>
                              </Grid>
                              <Grid item xs={4}>
                                <Typography component="span" variant="body2" fontWeight="regular" color="text" >
                                  Payment Date :&nbsp;
                                </Typography>
                                <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "82px" }}>
                                  {trainingDetails.expectedPaymentDate3 !== null
                                    ? trainingDetails.expectedPaymentDate3
                                    : trainingDetails.expectedPaymentDate2 !== null
                                      ? trainingDetails.expectedPaymentDate2
                                      : trainingDetails.expectedPaymentDate1 !== null
                                        ? trainingDetails.expectedPaymentDate1
                                        : trainingDetails.expectedPaymentDate}
                                </Typography>
                              </Grid>
                            </Grid>

                            <Grid container spacing={4} mb={1}>
                              <Grid item xs={4}>
                                <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                                  Training type :&nbsp;
                                </Typography>
                                <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "85px" }}>
                                  {trainingDetails.finalizedTrainingHour}
                                </Typography>
                              </Grid>
                              <Grid item xs={4}>
                                <Typography component="span" variant="body2" fontWeight="regular" color="text" >
                                  Training Start Time :&nbsp;
                                </Typography>
                                <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "45px" }}>
                                  {trainingDetails.finalizedStarttime}
                                </Typography>
                              </Grid>
                              <Grid item xs={4}>
                                <Typography component="span" variant="body2" fontWeight="regular" color="text" >
                                  Training End Time :&nbsp;
                                </Typography>
                                <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "54px" }}>
                                  {trainingDetails.finalizedEndtime}
                                </Typography>
                              </Grid>
                            </Grid>

                            <Grid container spacing={4} mb={1}>
                              <Grid item xs={12}>
                                <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                                  Finalized Commercials :&nbsp;
                                </Typography>
                                <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "80px" }}>
                                  {trainingDetails.finalizedCommercialsCurrency}&nbsp;{trainingDetails.finalizedCommercials}
                                </Typography>
                              </Grid>
                            </Grid>

                            <Grid container spacing={4} mb={1}>
                              <Grid item xs={12}>
                                <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                                  Finalized Training Schedule :&nbsp;
                                </Typography>
                                <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "48px" }}>
                                  {trainingDetails.finalizedScheduledate
                                    ? trainingDetails.finalizedScheduledate
                                      .replace(/'/g, "")
                                      .replace(/\[|\]/g, "")
                                      .split(", ")
                                      .join(", ")
                                    : ""}
                                </Typography>
                              </Grid>
                            </Grid>
                          </>
                        )}

                    </Grid>
                  </Grid>
                  <Grid container justifyContent="center" spacing={2} mt={2} style={{ marginTop: "-40px", marginBottom: "-80px" }}>
                    <Grid item>
                      <MKButton
                        variant="gradient"
                        color="info"
                        size="small"
                        onClick={() => onCancelClick()}
                        style={{ padding: '5px 10px' }}
                      >
                        Back
                      </MKButton>
                    </Grid>
                    {parseInt(trainingDetails.applyTrainingStatus) === 1 && (
                      <>
                        <Grid item>
                          <MKButton
                            variant="gradient"
                            color="info"
                            size="small"
                            onClick={() => onRemainderClick(trainingDetails)}
                            style={{ padding: '5px 10px' }}
                          >
                            Send Remainder
                          </MKButton>
                        </Grid>
                      </>
                    )}
                    {parseInt(trainingDetails.applyTrainingStatus) === 2 && (
                      <>
                        <Grid item>
                          <MKButton
                            variant="gradient"
                            color="info"
                            size="small"
                            onClick={() => onAgreeClick(trainingDetails)}
                            style={{ padding: '5px 10px' }}
                          >
                            Accept
                          </MKButton>
                        </Grid>
                      </>
                    )}
                    {parseInt(trainingDetails.applyTrainingStatus) === 5 && (
                      <>
                        <Grid item>
                          <MKButton
                            variant="gradient"
                            color="info"
                            size="small"
                            onClick={() => onConfirmTrainingClick(trainingDetails)}
                            style={{ padding: '5px 10px' }}
                          >
                            Confirm Training
                          </MKButton>
                        </Grid>
                      </>
                    )}
                    {parseInt(trainingDetails.applyTrainingStatus) === 8 && (
                      <>
                        <Grid item>
                          <MKButton
                            variant="gradient"
                            color="info"
                            size="small"
                            onClick={() => onSendInvoiceClick(trainingDetails)}
                            style={{ padding: '5px 10px' }}
                          >
                            Invoice Sent
                          </MKButton>
                        </Grid>
                      </>
                    )}
                    {[10, 20].includes(parseInt(trainingDetails.applyTrainingStatus)) && (
                      <>
                        <div>
                          {getFeedbackStatus(trainingDetails)}
                          <Modal open={showFeedbackModal === true} onClose={() => setShowFeedbackModal(false)} sx={{ display: "grid", placeItems: "center" }}>
                            <MKBox
                              position="relative"
                              width="780px"
                              display="flex"
                              flexDirection="column"
                              borderRadius="xl"
                              bgColor="white"
                              shadow="xl"
                            >
                              <div style={{ maxHeight: '90vh', overflowY: 'auto' }}>
                                <h2 style={{ whiteSpace: 'nowrap', fontSize: 'large', marginLeft: '10px', marginTop: '10px' }}>
                                  Feedback for the Training Partner {trainingDetails.trainingCompanyName} for the Training - {trainingDetails.trainingName}
                                </h2>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                  <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                                    Share your rating for the Training Company * -
                                  </Typography>
                                  <Stack spacing={1} style={{ marginLeft: '20px', marginTop: '10px' }}>
                                    <Rating
                                      name="half-rating"
                                      value={feedbackRating}
                                      precision={0.5}
                                      onChange={handleRatingChange}
                                    />
                                  </Stack>
                                </div>
                                <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                                  {feedbackQuestions.length > 0 && feedbackQuestions[0].question}
                                </Typography>
                                <Grid item xs={4} style={{ marginTop: "10px", marginBottom: "10px" }}>
                                  <div>
                                    <TextField
                                      label="Min: 10 characters, Max: 500 characters"
                                      multiline
                                      rows={4}
                                      variant="outlined"
                                      style={{
                                        width: '650px', marginLeft: "20px",
                                        borderColor: feedbackAnswer1.length >= 10 && feedbackAnswer1.length <= 500 && isFeedback1Interacted
                                          ? "initial"
                                          : "initial",
                                      }}
                                      value={feedbackAnswer1}
                                      error={isFeedback1Interacted && (feedbackAnswer1.length < 10 || feedbackAnswer1.length > 500)}
                                      helperText={
                                        isFeedback1Interacted && (feedbackAnswer1.length < 10 || feedbackAnswer1.length > 500)
                                          ? ""
                                          : ""
                                      }
                                      onChange={(e) => {
                                        setFeedbackAnswer1(e.target.value);
                                      }}
                                      onFocus={() => setIsFeedback1Interacted(true)}
                                    />
                                  </div>
                                </Grid>
                                <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                                  {feedbackQuestions.length > 0 && feedbackQuestions[1].question}
                                </Typography>
                                <Grid item xs={4} style={{ marginTop: "10px", marginBottom: "10px" }}>
                                  <div>
                                    <TextField
                                      label="Min: 10 characters, Max: 500 characters"
                                      multiline
                                      rows={4}
                                      variant="outlined"
                                      style={{
                                        width: '650px', marginLeft: "20px",
                                        borderColor: feedbackAnswer2.length >= 10 && feedbackAnswer2.length <= 500 && isFeedback2Interacted
                                          ? "initial"
                                          : "initial",
                                      }}
                                      value={feedbackAnswer2}
                                      fullWidth
                                      error={isFeedback2Interacted && (feedbackAnswer2.length < 10 || feedbackAnswer2.length > 500)}
                                      helperText={
                                        isFeedback2Interacted && (feedbackAnswer2.length < 10 || feedbackAnswer2.length > 500)
                                          ? ""
                                          : ""
                                      }
                                      onChange={(e) => {
                                        setFeedbackAnswer2(e.target.value);
                                      }}
                                      onFocus={() => setIsFeedback2Interacted(true)}
                                    />
                                  </div>
                                </Grid>
                                <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                                  {feedbackQuestions.length > 0 && feedbackQuestions[2].question}
                                </Typography>
                                <Grid item xs={4} style={{ marginTop: "10px", marginBottom: "10px" }}>
                                  <div>
                                    <TextField
                                      label="Min: 10 characters, Max: 500 characters"
                                      multiline
                                      rows={4}
                                      variant="outlined"
                                      style={{
                                        width: '650px', marginLeft: "20px",
                                        borderColor: feedbackAnswer3.length >= 10 && feedbackAnswer3.length <= 500 && isFeedback3Interacted
                                          ? "initial"
                                          : "initial",
                                      }}
                                      value={feedbackAnswer3}
                                      fullWidth
                                      error={isFeedback3Interacted && (feedbackAnswer3.length < 10 || feedbackAnswer3.length > 500)}
                                      helperText={
                                        isFeedback3Interacted && (feedbackAnswer3.length < 10 || feedbackAnswer3.length > 500)
                                          ? ""
                                          : ""
                                      }
                                      onChange={(e) => {
                                        setFeedbackAnswer3(e.target.value);
                                      }}
                                      onFocus={() => setIsFeedback3Interacted(true)}
                                    />
                                  </div>
                                </Grid>
                                <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                                  {feedbackQuestions.length > 0 && feedbackQuestions[3].question}
                                </Typography>
                                <Grid item xs={4} style={{ marginTop: "10px", marginBottom: "10px" }}>
                                  <div>
                                    <TextField
                                      label="Min: 10 characters, Max: 500 characters"
                                      multiline
                                      rows={4}
                                      variant="outlined"
                                      style={{
                                        width: '650px', marginLeft: "20px",
                                        borderColor: feedbackAnswer4.length >= 10 && feedbackAnswer4.length <= 500 && isFeedback4Interacted
                                          ? "initial"
                                          : "initial",
                                      }}
                                      value={feedbackAnswer4}
                                      fullWidth
                                      error={isFeedback4Interacted && (feedbackAnswer4.length < 10 || feedbackAnswer4.length > 500)}
                                      helperText={
                                        isFeedback2Interacted && (feedbackAnswer4.length < 10 || feedbackAnswer4.length > 500)
                                          ? ""
                                          : ""
                                      }
                                      onChange={(e) => {
                                        setFeedbackAnswer4(e.target.value);
                                      }}
                                      onFocus={() => setIsFeedback4Interacted(true)}
                                    />
                                  </div>
                                </Grid><Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                                  {feedbackQuestions.length > 0 && feedbackQuestions[4].question}
                                </Typography>
                                <Grid item xs={4} style={{ marginTop: "10px", marginBottom: "10px" }}>
                                  <div>
                                    <TextField
                                      label="Min: 10 characters, Max: 500 characters"
                                      multiline
                                      rows={4}
                                      variant="outlined"
                                      style={{
                                        width: '650px', marginLeft: "20px",
                                        borderColor: feedbackAnswer5.length >= 10 && feedbackAnswer5.length <= 500 && isFeedback5Interacted
                                          ? "initial"
                                          : "initial",
                                      }}
                                      value={feedbackAnswer5}
                                      fullWidth
                                      error={isFeedback5Interacted && (feedbackAnswer5.length < 10 || feedbackAnswer5.length > 500)}
                                      helperText={
                                        isFeedback5Interacted && (feedbackAnswer5.length < 10 || feedbackAnswer5.length > 500)
                                          ? ""
                                          : ""
                                      }
                                      onChange={(e) => {
                                        setFeedbackAnswer5(e.target.value);
                                      }}
                                      onFocus={() => setIsFeedback5Interacted(true)}
                                    />
                                  </div>
                                </Grid>
                                <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                                  {feedbackQuestions.length > 0 && feedbackQuestions[5].question}
                                </Typography>
                                <Grid item xs={4} style={{ marginTop: "10px", marginBottom: "10px" }}>
                                  <div>
                                    <TextField
                                      label="Min: 10 characters, Max: 500 characters"
                                      multiline
                                      rows={4}
                                      variant="outlined"
                                      style={{
                                        width: '650px', marginLeft: "20px",
                                        borderColor: feedbackAnswer6.length >= 10 && feedbackAnswer6.length <= 500 && isFeedback6Interacted
                                          ? "initial"
                                          : "initial",
                                      }}
                                      value={feedbackAnswer6}
                                      fullWidth
                                      error={isFeedback6Interacted && (feedbackAnswer6.length < 10 || feedbackAnswer6.length > 500)}
                                      helperText={
                                        isFeedback6Interacted && (feedbackAnswer6.length < 10 || feedbackAnswer6.length > 500)
                                          ? ""
                                          : ""
                                      }
                                      onChange={(e) => {
                                        setFeedbackAnswer6(e.target.value);
                                      }}
                                      onFocus={() => setIsFeedback6Interacted(true)}
                                    />
                                  </div>
                                </Grid>
                                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '10px' }}>
                                  <MKButton variant="gradient" color="info" size="small" disabled={!feedbackRating || !feedbackAnswer1 || feedbackAnswer1.length < 10 || feedbackAnswer1.length > 500
                                    || !feedbackAnswer2 || feedbackAnswer2.length < 10 || feedbackAnswer2.length > 500
                                    || !feedbackAnswer3 || feedbackAnswer3.length < 10 || feedbackAnswer3.length > 500
                                    || !feedbackAnswer4 || feedbackAnswer4.length < 10 || feedbackAnswer4.length > 500
                                    || !feedbackAnswer5 || feedbackAnswer5.length < 10 || feedbackAnswer5.length > 500
                                    || !feedbackAnswer6 || feedbackAnswer6.length < 10 || feedbackAnswer6.length > 500}
                                    onClick={() => onSubmitFeedbackClick(trainingDetails)} style={{ padding: '5px 10px' }}>Submit Feedback</MKButton>
                                </div>
                              </div>
                            </MKBox>
                          </Modal>
                        </div>
                      </>
                    )}
                    {parseInt(trainingDetails.applyTrainingStatus) === 10 && (
                      <>
                        <Grid item>
                          <MKButton
                            variant="gradient"
                            color="info"
                            size="small"
                            onClick={() => onPaymentNotReceivedClick(trainingDetails)}
                            style={{ padding: '5px 10px' }}
                          >
                            Payment Not Received
                          </MKButton>
                        </Grid>
                      </>
                    )}
                    {parseInt(trainingDetails.applyTrainingStatus) === 10 && (
                      <>
                        <Grid item>
                          <MKButton
                            variant="gradient"
                            color="info"
                            size="small"
                            onClick={() => onPaymentReceivedClick(trainingDetails)}
                            style={{ padding: '5px 10px' }}
                          >
                            Payment Received
                          </MKButton>
                        </Grid>
                      </>
                    )}
                  </Grid>
                </Grid>
              </Container>

            </MKBox>
            {/* <Posts /> */}
          </Card>
          {/* <Contact /> */}
          {/* <Footer /> */}
          <div style={{ flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <MKBox position="center" zIndex={2} style={{ bottom: 0 }}>
              <SimpleFooter />
            </MKBox>
          </div>
        </MKBox>
      </LoadingOverlay>
    </>
  );
}

export default Author;
